import type { SystemProps } from '@hover/blueprint';
import { Box, Button, Icon } from '@hover/blueprint';
import { iMoreHorizontal } from '@hover/icons';
import React from 'react';

import { ProjectShareButton } from 'src/modules/homeownerApp/components/Projects/Project/ProjectShareButton';
import type { Project as ProjectType } from 'src/shared/graphql/generated';

import { TopBar } from '../../TopBar';

const TOP_BAR_NAME_CHACACTER_LIMIT = 20;

const formatTopProjectName = (name: string) =>
  name.length > TOP_BAR_NAME_CHACACTER_LIMIT
    ? `${name.slice(0, TOP_BAR_NAME_CHACACTER_LIMIT)}...`
    : name;

interface ProjectHeaderProps {
  id: ProjectType['id'];
  name: string;
  onMoreActionsClick: () => void;
  projectNameVisibilityHandler?: React.RefObject<HTMLDivElement>;
}

const ProjectHeader = ({
  id,
  name,
  onMoreActionsClick,
  projectNameVisibilityHandler,
}: ProjectHeaderProps) => {
  const topbarProps = {
    paddingX: 500,
    display: { base: 'flex', tablet: 'none' },
  } satisfies SystemProps;

  return (
    <>
      <TopBar
        moreActionsHandler={() => onMoreActionsClick()}
        project
        projectId={id}
        visibilityElementRef={projectNameVisibilityHandler}
        {...topbarProps}
      >
        <Button
          maxWidth={{ base: 700, tablet: undefined }}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          size="small"
          variant="ghost"
        >
          {formatTopProjectName(name)}
        </Button>
      </TopBar>
      <Box
        alignItems="center"
        display={{ base: 'none', tablet: 'flex' }}
        p={800}
        position="absolute"
        right={0}
        top={0}
        width={700}
        zIndex={1}
      >
        <ProjectShareButton id={id} />
        <Button
          height={350}
          label="moreActions"
          ml="auto"
          onClick={() => onMoreActionsClick()}
          shape="circle"
          variant="ghost"
          width={350}
        >
          <Icon icon={iMoreHorizontal} />
        </Button>
      </Box>
    </>
  );
};

export { ProjectHeader };
